import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FooterContainer } from './styled';
import {
  faUser,
  faHome,
  faSearch,
  faMoneyCheckDollar,
  faHeart,
} from '@fortawesome/free-solid-svg-icons';
import {
  ROUTE_CATEGORIES,
  ROUTE_HOME,
  ROUTE_PROFILE,
  ROUTE_PROMOCODES,
  ROUTE_SAVED,
} from '../../common/constants';
import { useTranslation } from 'react-i18next';
import { useLocalePath } from '../../common/hooks';
import { stripLangPrefix } from '../../common/utils/locale.utils';

const FOOTER_MENU = [
  {
    label: 'menu.home',
    icon: faHome,
    route: ROUTE_HOME,
  },
  {
    label: 'menu.categories',
    icon: faSearch,
    route: ROUTE_CATEGORIES,
  },
  {
    label: 'menu.promocodes',
    icon: faMoneyCheckDollar,
    route: ROUTE_PROMOCODES,
  },
  {
    label: 'menu.favorites',
    icon: faHeart,
    route: ROUTE_SAVED,
  },
  {
    label: 'menu.profile',
    icon: faUser,
    route: ROUTE_PROFILE,
  },
];

export const Footer = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const localePath = useLocalePath();
  const { pathname } = useLocation();
  const [isActive, setIsActive] = useState(getActiveIndex());

  function getActiveIndex() {
    const cleanPath = stripLangPrefix(pathname);
    return FOOTER_MENU.findIndex(
      (menuItem) => cleanPath.split('/')[1] === menuItem.route.split('/')[1],
    );
  }

  useEffect(() => {
    setIsActive(getActiveIndex());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <FooterContainer>
      {FOOTER_MENU.map((menu, index) => (
        <Link to={localePath(menu.route)} key={menu.route}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              rowGap: 4,
            }}
            onClick={() => setIsActive(index)}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: isActive === index ? `${theme.primary.main}1A` : `${theme.text}1A`,
                borderRadius: 12,
                height: 36,
                width: 36,
              }}
            >
              <FontAwesomeIcon
                icon={menu.icon}
                color={isActive === index ? theme.primary.main : `${theme.text}1A`}
              />
            </div>
            <span
              style={{
                fontSize: '12px',
                fontFamily: 'Medium',
                whiteSpace: 'nowrap',
                color: isActive === index ? theme.text : `${theme.text}4D`,
                textAlign: 'center',
              }}
            >
              {t(menu.label)}
            </span>
          </div>
        </Link>
      ))}
    </FooterContainer>
  );
};
